import { BREAKPOINT_SMALL } from '@big-red-group/storefront-common-ui'
import styled from 'styled-components'

export const Wrapper = styled.div``
export const ReviewContainer = styled.div`
  display: flex;
  align-items: flex-end;

  column-gap: 16px;
  row-gap: 10px;

  > span {
    line-height: 1;
  }

  @media (max-width: ${BREAKPOINT_SMALL}px) {
    flex-wrap: wrap;

    > span {
      width: 100%;
      color: var(--text-primary);
    }
  }
`
export const RatingScore = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;

  span:first-child {
    font-size: 30px;
    margin-left: 4px;
    font-weight: bold;
    line-height: 1;
    display: inline-block;
    position: relative;
    top: 4px;
  }
  span:last-child {
    font-size: 20px;
    color: var(--text-primary-light);
    font-weight: var(--font-bold);
    display: inline-block;
  }
`
